<template>
    <ul class="people_list">
        <li v-for="(item, index) in list" :key="index + type" class="player mb24" :style="{ borderBottom }">
            <div class="people_info">
                <cl-avatar width="40" height="40" :src="item.avatar"> </cl-avatar>
                <div class="ml10">
                    <p class="name fs14 SysFontM" :title="item['name' + $lang] || item.name">
                        <span class="number AkrobatM" v-if="type === 'player'">{{ item.number }}</span>
                        {{ item['name' + $lang] || item.name }}
                    </p>
                    <p class="title mt2 fs14" v-if="type === 'coaching'">{{ item.title || $nullText }}</p>
                </div>
            </div>
        </li>
    </ul>
</template>
<script>
    /**
     * ComponentName: players list
     * Created Date:2022/5/24
     * Author: shishuo·zhang
     * 组件说明：
     * 这组组件是展示球员，教练员的组件
     * eg:
     *     <cl-players-list></cl-players-list>
     */
    export default {
        name: 'cl-players-list',
        props: {
            // 球员或者教练员列表
            list: {
                type: Array,
                default: () => [],
            },
            // 球员或者教练员类型 player || coaching
            type: {
                type: String,
                default: 'player',
            },
            // 底部边框
            borderBottom: {
                type: String,
                default: '1px solid #E9EDF3',
            },
        },
    }
</script>

<style lang="scss" scoped>
    .people_list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        color: #81818a;
        .people_info {
            display: flex;
            align-items: center;
        }
        li {
            width: 20%;
            position: relative;
            padding: 13px 0;
            margin-right: 5%;
            .name {
                line-height: 20px;
                color: $base-font-major;
            }
            .title {
                color: $base-font-minor;
            }
            .number {
                font-size: 16px;
                margin-right: 8px;
                color: #7a70f6;
            }
        }
    }
</style>
